import { useState } from 'react';
import { registerUser } from '../../services/auth/registerService.js';
import { isTextValid, isUsernameValid, isEmailValid, isPasswordValid } from '../../utils/validations/registerValidations.js';

// Lógica del formulario en un Custom Hook
export const useRegister = () => {
    const [form, setForm] = useState({
        name: '',
        lastname: '',
        username: '',
        email: '',
        password: ''
    });

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);
    const clearError = () => setError('');
    const clearSuccess = () => setSuccess('');
    const clearValidationErrors = () => setValidationErrors([]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const submit = async () => {
        // LIMPIEZA GLOBAL
        setError('');
        setSuccess('');
        setValidationErrors([]);

        const { name, lastname, username, email, password } = form;

        if (!isTextValid(name) || !isTextValid(lastname)){
            setSuccess('');
            setError('Los campos de nombre solo pueden contener letras.');
            return;
        }
        if (!isUsernameValid(username)){
            setSuccess('');
            setError('El campo username solo puede contener letras y números.');
            return;
        }
        if (!isEmailValid(email)){
            setSuccess('');
            setError('El correo electrónico no es válido.');
            return;
        }
        if (!isPasswordValid(password)){
            setSuccess('');
            setError('La contraseña debe tener al menos 7 caracteres.');
            return;
        }
        // Si todo esta validado, procedimiento guardar
        try {
            await registerUser(form);
            setSuccess('Su cuenta ha sido registrada exitosamente.');
        } catch (err) {
            // Validación del archivo: middleware/validator.js del backend
            if (err.response?.status === 400 && Array.isArray(err.response.data?.errors)) {
                setValidationErrors(err.response.data.errors);
                return;
            }
            // Error general
            setError(
                err.response?.data?.error || 
                err.response?.data?.message || 
                'Error al registrar usuario'
            );
        }
    };

    return {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        clearError,
        clearSuccess,
        clearValidationErrors
    };
}